import { post } from "../helpers/api_helper";

export const getAttendanceSalaryDate = async (unitId = localStorage.getItem("unit_id")) => {
  const formData = new FormData();
  formData.append("unit_id", unitId);
  return await post(process.env.REACT_APP_EMPLOYEES_SALARYDATE, formData);
};